import React from "react";

export const chevronLeft = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 16 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.344 24L15.6406 20.7032L6.93744 12L15.6406 3.29681L12.344 2.88201e-07L0.343993 12L12.344 24Z"
        fill="currentColor"
      />
    </svg>
  );
};
